// extracted by mini-css-extract-plugin
export default {"button":"nOQhyY","disabled":"k2BjXj","mobile-button":"o5RqC9","mobileButton":"o5RqC9"};